import Toast from '@/lib/toast'
import moment from 'moment'
import connectManagerClient from '@/lib/connect-client/connect-manager-client'
import connectHttpBase from '@/lib/connect-client/connect-http-base'
import ApplicationConfig from '@/lib/application-config'

import * as Constants from '@/lib/constants'

import i18n from '@/lib/i18n'
import router from '@/router'
import storage from '@/lib/storage'
import store from '../index'

import * as Types from '../mutation-types'
import connectMyRegionClient from '@/lib/connect-client/connect-my-region-client'
import { SIMPLE_SIGN_UP_FINISHED } from '../mutation-types'
import PurchaseInfo from '@/lib/purchase-info'

const state = {
  accessToken: undefined,
  accessTokenExpiredAt: moment(),
  nowLoggingIn: false,
  loginRememberMe: false,
  userInfo: {},
  searchedUserInfo: null,
  incomingSubscriptionRequests: [],
  outgoingSubscriptionRequests: [],
  subscriptionInfo: { subscribingAccounts: [], subscriberAccounts: [], subscribingGroups: [] },
  soracomSubscribers: {},
  awsSession: null,
  devicesInfo: { devices: [] },
  webMarkers: [],
  passwordEntered: true,
  subscribingUserInfos: [],
  userGroupsInfo: {},
}

const getters = {
  accessToken: state => state.accessToken,
  accessTokenExpiredAt: state => state.accessTokenExpiredAt,
  nowLoggingIn: state => state.nowLoggingIn,
  userInfo: state => state.userInfo,
  loginUsername: state => state.userInfo.username,
  loginNickname: state => state.userInfo.nickname,
  subscribingAccounts: state => {
    return state.subscriptionInfo.subscribingAccounts
  },
  subscribingGroups: state => {
    return state.subscriptionInfo.subscribingGroups
  },
  subscriberAccounts: state => {
    return state.subscriptionInfo.subscriberAccounts
  },
  searchedUserInfo: state => state.searchedUserInfo,
  incomingSubscriptionRequests: state => state.incomingSubscriptionRequests,
  outgoingSubscriptionRequests: state => state.outgoingSubscriptionRequests,
  myProducts: state => state.myProducts,
  soracomSubscribers: state => state.soracomSubscribers,

  awsSession: state => state.awsSession,

  devicesInfo: state => state.devicesInfo,
  webMarkers: state => state.webMarkers,
  passwordEntered: state => state.passwordEntered,
  subscribingUserInfos: state => state.subscribingUserInfos,

  userGroupsInfo: state => state.userGroupsInfo,
}

const mutations = {
  [Types.LOGIN_STARTED](state) {
    state.nowLoggingIn = true
  },

  [Types.LOGIN_SUCCESS](state, loginInfo) {
    state.nowLoggingIn = false
    state.loginRememberMe = loginInfo.rememberMe
    state.accessToken = loginInfo.accessToken
    state.accessTokenExpiredAt = loginInfo.accessTokenExpiredAt
    state.userInfo = loginInfo.userInfo
  },

  [Types.LOGIN_FAILURE](state) {
    state.nowLoggingIn = false
  },

  [Types.SIMPLE_SIGN_UP_STARTED](state) {
    state.nowLoggingIn = true
  },
  [Types.SIMPLE_SIGN_UP_FINISHED](state) {
    state.nowLoggingIn = false
  },

  [Types.REFRESH_TOKEN_SUCCESS](state, refreshTokenResult) {
    state.accessToken = refreshTokenResult.accessToken
    state.accessTokenExpiredAt = refreshTokenResult.accessTokenExpiredAt
    state.userInfo = refreshTokenResult.userInfo
  },

  [Types.LOGOUT](state) {
    state.accessToken = undefined
    state.accessTokenExpiredAt = undefined
  },

  [Types.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo
  },

  [Types.SET_SUBSCRIPTION_INFO](state, subscriptionInfo) {
    state.subscriptionInfo = subscriptionInfo
  },

  [Types.SET_SERACHED_USER_INFO](state, userInfo) {
    state.searchedUserInfo = userInfo
  },

  [Types.CLEANUP_SERACHED_USER_INFO](state) {
    state.searchedUserInfo = null
  },

  [Types.SET_INCOMING_SUBSCRIPTION_REQUESTS](state, requests) {
    state.incomingSubscriptionRequests = requests
  },

  [Types.SET_OUTGOING_SUBSCRIPTION_REQUESTS](state, requests) {
    state.outgoingSubscriptionRequests = requests
  },

  [Types.ADD_SORACOM_SUBSCRIBER](state, soracomSubscriberInfo) {
    state.soracomSubscribers[soracomSubscriberInfo.subscriber.imsi] = soracomSubscriberInfo
  },

  [Types.SET_AWS_SESSION_INFO](state, awsSession) {
    state.awsSession = awsSession
  },

  [Types.SET_DEVICES_INFO](state, devicesInfo) {
    state.devicesInfo = devicesInfo
  },

  [Types.SET_WEB_MARKERS_INFO](state, webMarkers) {
    state.webMarkers = webMarkers
  },
  [Types.PASSWORD_ENTERED](state, passwordEntered) {
    state.passwordEntered = passwordEntered
  },
  [Types.CLEAR_SUBSCRIBING_USER_INFOS](state) {
    state.subscribingUserInfos = []
  },
  [Types.ADD_SUBSCRIBING_USER_INFO](state, userInfo) {
    state.subscribingUserInfos.push(userInfo)
  },

  [Types.SET_USER_GROUPS_INFO](state, userGroupsInfo) {
    state.userGroupsInfo = userGroupsInfo
  },
}

const actions = {
  setTestToken({ commit }, loginInfo) {
    commit(Types.LOGIN_SUCCESS, loginInfo)
  },
  _handleTokenResponse(commit, rememberMe, tokenResponse) {
    // リフレッシュトークン保存
    const refreshToken = tokenResponse.refreshToken
    const refreshTokenExpiredAt = tokenResponse.refreshTokenExpiredAt
    storage.saveRefreshTokens(refreshToken, refreshTokenExpiredAt)

    // UserInfo保存
    const userInfo = tokenResponse.userInfo
    commit(Types.SET_USER_INFO, userInfo)
    storage.saveUserInfo(userInfo)

    // 表示単位系
    const systemOfUnits = userInfo.systemOfUnits
    commit(Types.SET_SYSTEM_OF_UNITS, systemOfUnits)

    // Langの設定 --> Langはstorageに保管することにする
    i18n.setUserLang(userInfo)

    // SubscriptionInfo
    const subscriptionInfo = tokenResponse.subscriptionInfo
    commit(Types.SET_SUBSCRIPTION_INFO, subscriptionInfo)

    // アクセストークン
    const accessToken = tokenResponse.accessToken
    const accessTokenExpiredAt = tokenResponse.accessTokenExpiredAt

    // Mutations
    const loginInfo = { rememberMe, userInfo, accessToken, accessTokenExpiredAt }
    commit(Types.LOGIN_SUCCESS, loginInfo)

    // AWS Cred情報
    const awsSession = tokenResponse.awsSession
    if (awsSession) {
      commit(Types.SET_AWS_SESSION_INFO, awsSession)
    }

    // ユーザのパスワード作成情報取得
    store.dispatch('passwordEntered')

    // Caster関連
    store.dispatch('listCasterBasesAndRovers')
  },

  _loginInitProcess(commit, rememberMe, tokenResponse, nextRoute) {
    storage.saveRememberMe(rememberMe)
    actions._handleTokenResponse(commit, rememberMe, tokenResponse)

    if (!tokenResponse.userInfo.isPayer && nextRoute !== '/sso/shopify') {
      store.dispatch('initFields2', {
        fieldEmptyAction: Constants.INIT_FIELD_OPTION_SHOW_FIELD_IMPORT,
      })
    }

    store.dispatch('getCentroidOfUserFields')

    store.dispatch('listOperationAvailableTypes')
    store.dispatch('fetchSubscriptionInfo')
    store.dispatch('getStripeInfo')
    store.dispatch('listBillingPlans')

    store.dispatch('listDevices')
    store.dispatch('listWebMarkers')

    // フォローリクエスト情報を取得
    store.dispatch('listIncomingSubscriptionRequests')

    // ユーザーグループ情報(EAPテスターなどのグループ)
    store.dispatch('getUserGroupsInfo')

    // Grow関連
    store.dispatch('listPfObservations')
    store.dispatch('listAtObservations')

    // リフレッシュトークンデーモンスタート
    connectManagerClient.startRefreshTokenDaemon()
    const purchaseInfo = storage.getPurchaseInfo()
    if (purchaseInfo.isGoogleCanceled()) {
      nextRoute = '/free'
    }
    router.push(nextRoute)
  },

  simpleSignUp({ commit }, request) {
    commit(Types.SIMPLE_SIGN_UP_STARTED)
    connectMyRegionClient
      .getMyRegion()
      .then(response => {
        // SimpleSignUp
        request.region = response.data
        connectManagerClient
          .simpleSignUp(request)
          .then(response => {
            request.onSignUpSuccessHandler()
            Toast.i18nSuccess('customSimpleSignUpSuccess')
          })
          .catch(error => {
            console.error(error)
            if (error.response.status === 406) {
              Toast.i18nError('customSimpleSignUpUserAlreadyExists')
            } else {
              Toast.i18nError('customSimpleSignUpServerError')
            }
          })
          .finally(() => {
            commit(Types.SIMPLE_SIGN_UP_FINISHED)
          })
      })
      .catch(error => {
        console.error(error)
        Toast.i18nError('customSimpleSignUpFailed')
        commit(Types.SIMPLE_SIGN_UP_FINISHED)
      })
  },

  simpleSignUpAndSignIn({ commit }, request) {
    commit(Types.SIMPLE_SIGN_UP_STARTED)
    connectMyRegionClient
      .getMyRegion()
      .then(response => {
        request.region = response.data
        connectManagerClient
          .simpleSignUpAndSignIn(request)
          .then(response => {
            const nextRoute = '/feed'
            actions._loginInitProcess(commit, true, response.data, request.nextRoute)
          })
          .catch(error => {
            console.error(error)
            if (error.response.status === 406) {
              Toast.i18nError('customSimpleSignUpAndSignInError')
            } else {
              Toast.i18nError('customSimpleSignUpServerError')
            }
          })
          .finally(() => {
            request.onSignUpSuccessHandler()
            commit(Types.SIMPLE_SIGN_UP_FINISHED)
          })
      })
      .catch(error => {
        console.error(error)
        Toast.i18nError('customSimpleSignUpFailed')
        request.onSignUpSuccessHandler()
        commit(Types.SIMPLE_SIGN_UP_FINISHED)
      })
  },

  createPassword({ commit }, createPasswordInfo) {
    const newPassword = createPasswordInfo.newPassword
    connectManagerClient
      .createPassword(newPassword)
      .then(response => {
        commit(Types.PASSWORD_ENTERED, true)
        router.replace({ name: 'UserPasswordSuccess' })
      })
      .catch(error => {
        console.error(error)
        Toast.error('create password failed.')
      })
  },
  passwordEntered({ commit }) {
    connectManagerClient
      .passwordEntered()
      .then(response => {
        const passwordEntered = response.data
        commit(Types.PASSWORD_ENTERED, passwordEntered)
      })
      .catch(error => {
        console.error(error)
      })
  },

  oAuthLogin({ commit }, request) {
    commit(Types.SIMPLE_SIGN_UP_STARTED)
    connectMyRegionClient
      .getMyRegion()
      .then(response => {
        request.region = response.data
        request.appId = ApplicationConfig.getClientId()
        request.deviceId = Constants.DEVICE_ID
        request.deviceManufacturer = Constants.DEVICE_MANUFACTURER
        request.deviceModel = Constants.DEVICE_MODEL
        request.deviceSystemVersion = Constants.DEVICE_SYSTEM_VERSION
        request.secretHash = connectHttpBase.calclateSecretHash(request.email)

        connectManagerClient
          .oAuthLogin(request)
          .then(response => {
            request.onSignUpSuccessHandler()
            const rememberMe = true
            actions._loginInitProcess(commit, rememberMe, response.data, request.nextRoute)
          })
          .catch(error => {
            console.error(error)
            Toast.i18nError('customOAuthServerError')

            commit(Types.SIMPLE_SIGN_UP_FINISHED)
            router.push({ name: 'Login' })
          })
      })
      .catch(error => {
        console.error(error)
        Toast.i18nError('customOAuthFailed')
        commit(Types.SIMPLE_SIGN_UP_FINISHED)
        router.push({ name: 'Login' })
      })
  },

  impersonate({ commit }, targetUserEmail) {
    connectManagerClient
      .impersonate(targetUserEmail)
      .then(response => {
        actions._handleTokenResponse(commit, false, response.data)
        store.dispatch('initFields2')
        store.dispatch('listOperationAvailableTypes')
        store.dispatch('fetchSubscriptionInfo')
        router.push({ name: 'Feed' })
      })
      .catch(error => {
        console.error(error)
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('Switch User failed.')
        }
      })
  },

  login({ commit }, loginInfo) {
    commit(Types.LOGIN_STARTED)
    const credentials = loginInfo.credentials
    connectManagerClient
      .login(credentials)
      .then(response => {
        // RememberMe保存
        const rememberMe = credentials.rememberMe
        actions._loginInitProcess(commit, rememberMe, response.data, loginInfo.nextRoute)
      })
      .catch(error => {
        commit(Types.LOGIN_FAILURE)
        console.error(error)
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('Login failed.')
        }
      })
  },

  refreshTokenSuccess({ commit }, refreshTokenResult) {
    // リフレッシュトークン保存
    const refreshToken = refreshTokenResult.refreshToken
    const refreshTokenExpiredAt = refreshTokenResult.refreshTokenExpiredAt
    storage.saveRefreshTokens(refreshToken, refreshTokenExpiredAt)

    // UserInfo保存
    let userInfo = refreshTokenResult.userInfo
    storage.saveUserInfo(userInfo)

    // 表示単位系
    const systemOfUnits = userInfo.systemOfUnits
    commit(Types.SET_SYSTEM_OF_UNITS, systemOfUnits)

    // Langの設定
    i18n.setUserLang(userInfo)

    // Mutations
    commit(Types.REFRESH_TOKEN_SUCCESS, refreshTokenResult)

    // AWS Cred情報
    const awsSession = refreshTokenResult.awsSession
    if (awsSession) {
      commit(Types.SET_AWS_SESSION_INFO, awsSession)
    }

    // Fields
    if (store.getters.fields.length == 0) {
      store.dispatch('initFields2')
    }

    // そのユーザーの全圃場重心
    store.dispatch('getCentroidOfUserFields')

    // AvailableOperationTypesも取得しておく
    store.dispatch('listOperationAvailableTypes')
    store.dispatch('fetchSubscriptionInfo')

    // StripeInfo
    store.dispatch('getStripeInfo')

    // BillingPlans
    store.dispatch('listBillingPlans')

    // デバイス関連
    store.dispatch('listDevices')

    // WebMarker関連
    store.dispatch('listWebMarkers')

    // ユーザのパスワード作成情報取得
    store.dispatch('passwordEntered')

    // フォローリクエスト情報を取得
    store.dispatch('listIncomingSubscriptionRequests')

    // ユーザーグループ情報(EAPテスターなどのグループ)
    store.dispatch('getUserGroupsInfo')

    // Grow関連
    store.dispatch('listPfObservations')
    store.dispatch('listAtObservations')

    // Caster関連
    store.dispatch('listCasterBasesAndRovers')
  },

  logout({ commit }) {
    const lang = i18n.getUserLang()
    storage.removeRefreshTokens()
    commit(Types.LOGOUT)
// TEMP     console.log(Constants.LOGOUT_URLS)
// TEMP     console.log(lang)
    let url = Constants.LOGOUT_URLS[lang]
// TEMP     console.log(url)
    if (!url) {
      url = Constants.LOGOUT_URLS[Constants.LANG_DEFAULT]
    }
    window.location.href = url
  },
  logoutForNoRedirect({ commit }) {
    storage.removeRefreshTokens()
    commit(Types.LOGOUT)
  },

  updateUser({ commit }, userData) {
    // Invoke API
    connectManagerClient
      .updateUser(userData)
      .then(response => {
        const userInfo = response.data
        storage.saveUserInfo(userInfo)
        commit(Types.SET_USER_INFO, userInfo)
        store.dispatch('setPurchaseInfoFromUserInfo', userInfo)
        Toast.i18nSuccess('customSaveSuccess')
        store.dispatch('listOperationAvailableTypes')
      })
      .catch(error => {
        console.error(error)
      })
  },

  getMe({ commit }, params = {}) {
    connectManagerClient.getMe().then(response => {
      const userInfo = response.data
      storage.saveUserInfo(userInfo)
      commit(Types.SET_USER_INFO, userInfo)
      store.dispatch('setPurchaseInfoFromUserInfo', userInfo)
      const onSuccess = params.onSuccess
      if (onSuccess) {
        onSuccess()
      }
    })
  },

  getSubscribingUserInfo({ commit }, subscriptionInfo) {
    commit(Types.CLEAR_SUBSCRIBING_USER_INFOS)
    let subscribingUuids = []
    subscriptionInfo.subscribingAccounts.forEach(acc => {
      subscribingUuids.push(acc.uuid)
    })
    subscriptionInfo.subscribingGroups.forEach(group => {
      group.groupUsernames.forEach(username => {
        subscribingUuids.push(username)
      })
    })
    subscribingUuids.forEach(uuid => {
      connectManagerClient.getUserInfo(uuid).then(response => {
        const userInfo = response.data
        const existing = store.getters.subscribingUserInfos.findIndex(sui => sui.username === userInfo.username)
        if (existing === -1) {
          commit(Types.ADD_SUBSCRIBING_USER_INFO, userInfo)
        }
      })
    })
  },

  changePassword({ commit }, changePasswordInfo) {
    const currentPassword = changePasswordInfo.currentPassword
    const newPassword = changePasswordInfo.newPassword
    connectManagerClient
      .changePassword(currentPassword, newPassword)
      .then(response => {
        router.replace({ name: 'UserPasswordSuccess' })
      })
      .catch(error => {
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
          // alert('message') //FIXME
        } else {
          Toast.error('change password failed.')
          // alert('message') //FIXME
        }
      })
  },

  fetchSubscriptionInfo({ commit }, nextPage) {
    connectManagerClient.fetchSubscriptionInfo().then(response => {
      const subscriptionInfo = response.data
      commit(Types.SET_SUBSCRIPTION_INFO, subscriptionInfo)
      store.dispatch('getSubscribingUserInfo', subscriptionInfo)
      if (nextPage) {
        router.push({ name: nextPage })
      }
    })
  },

  searchUserForFollowing({ commit }, email) {
    connectManagerClient
      .searchUserByEmail(email)
      .then(response => {
        let userInfo = response.data
        commit(Types.SET_SERACHED_USER_INFO, userInfo)
      })
      .catch(error => {
        commit(Types.SET_SERACHED_USER_INFO, null)
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('search user failed.')
        }
      })
  },

  cleanupSearchedUserInfo({ commit }) {
    commit(Types.CLEANUP_SERACHED_USER_INFO)
  },

  sendFollowRequest({ commit }, toUsername) {
    connectManagerClient
      .sendFollowRequest(toUsername)
      .then(response => {
        Toast.i18nSuccess('customSendFollowRequestMessage')
        store.dispatch('cleanupSearchedUserInfo')
        store.dispatch('listIncomingSubscriptionRequests')
        store.dispatch('listOutgoingSubscriptionRequests')
      })
      .catch(error => {
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('sending follow request failed.')
        }
      })
  },

  listIncomingSubscriptionRequests({ commit }) {
    const username = getters.loginUsername
    connectManagerClient
      .listIncomingSubscriptionRequests(username)
      .then(response => {
        commit(Types.SET_INCOMING_SUBSCRIPTION_REQUESTS, response.data)
      })
      .catch(error => {
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('listIncomingSubscriptionRequests failed.')
        }
      })
  },

  listOutgoingSubscriptionRequests({ commit }) {
    const username = getters.loginUsername
    connectManagerClient
      .listOutgoingSubscriptionRequests(username)
      .then(response => {
        commit(Types.SET_OUTGOING_SUBSCRIPTION_REQUESTS, response.data)
      })
      .catch(error => {
        if (error.response) {
          const message = error.response.data.message
          Toast.error(message)
        } else {
          Toast.error('listOutgoingSubscriptionRequests failed.')
        }
      })
  },

  allowFollowRequest({ commit }, subscriptionRequest) {
    connectManagerClient.allowSubscriptionRequest(subscriptionRequest).then(response => {
      store.dispatch('fetchSubscriptionInfo', 'UserConnections')
      store.dispatch('listIncomingSubscriptionRequests')
      store.dispatch('listOutgoingSubscriptionRequests')
      Toast.i18nSuccess('customAllowFollowRequest', { fromNickname: subscriptionRequest.fromNickname })
    })
  },

  denyFollowRequest({ commit }, subscriptionRequest) {
    connectManagerClient.denySubscriptionRequest(subscriptionRequest).then(response => {
      store.dispatch('fetchSubscriptionInfo', 'UserConnections')
      store.dispatch('listIncomingSubscriptionRequests')
      store.dispatch('listOutgoingSubscriptionRequests')
    })
  },

  deleteFollowRequest({ commit }, subscriptionRequest) {
    connectManagerClient
      .deleteFollowRequest(subscriptionRequest)
      .then(response => {
        store.dispatch('listOutgoingSubscriptionRequests')
        store.dispatch('fetchSubscriptionInfo')
      })
      .catch(error => {
        console.error(error)
        store.dispatch('listIncomingSubscriptionRequests')
        store.dispatch('listOutgoingSubscriptionRequests')
      })
  },

  unsubscribeAccount({ commit }, accountUuid) {
    connectManagerClient.unsubscribeAccount(accountUuid).then(response => {
      store.dispatch('fetchSubscriptionInfo')
      store.dispatch('refreshAccessToken')
      Toast.i18nSuccess('customUnfollowMessage')
    })
  },

  refreshAccessToken({ commit }) {
    connectManagerClient.refreshAccessToken().then(response => {
      store.dispatch('refreshTokenSuccess', response.data)
    })
  },

  updateUserIcon({ commit }, params) {
    connectManagerClient.updateUserIcon(params).then(response => {
      store.dispatch('getMe')
      Toast.i18nSuccess('customUpdatedIconMessage')
    })
  },

  // 現状ではlistOnlyAgriBusNaviをdispatchします
  listDevices({ commit }) {
    store.dispatch('listOnlyAgriBusNavi')
  },

  listOnlyAgriBusNavi({ commit }) {
    connectManagerClient
      .listOnlyAgriBusNavi()
      .then(response => {
        const devicesInfo = response.data
        commit(Types.SET_DEVICES_INFO, devicesInfo)
        store.dispatch('initRealtimeInfos', devicesInfo)
      })
      .catch(ignore => {
        console.error(ignore)
      })
  },

  updateWebMarker({ commit }, params) {
    const updateWebMarkerRequest = {
      username: params.device.username,
      deviceId: params.device.id,
      trackColor: params.trackColor,
      trackName: params.trackName,
    }
    const callback = params.callback
    connectManagerClient
      .updateWebMarker(updateWebMarkerRequest)
      .then(response => {
        store.dispatch('listWebMarkers', { callback })
      })
      .catch(error => {
        console.error(error)
      })
  },

  listWebMarkers({ commit }, params) {
    let callback = undefined
    if (params) {
      callback = params.callback
    }
    connectManagerClient
      .listWebMarkers()
      .then(response => {
        const webMarkers = response.data.webMarkers
        if (webMarkers) {
          commit(Types.SET_WEB_MARKERS_INFO, webMarkers)
        }
        if (callback) {
          callback()
        }
      })
      .catch(error => {
        console.error(error)
      })
  },

  getUserGroupsInfo({ commit }) {
    connectManagerClient
      .getUserGroupsInfo()
      .then(response => {
        commit(Types.SET_USER_GROUPS_INFO, response.data)
      })
      .catch(error => {
        console.error(error)
      })
  },
  /*
  // pay.jsへの移行
  updateCustomerName({ commit }, params) {
    connectManagerClient
      .updateCustomerName(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        console.error(error)
      })
  },

  // pay.jsへの移行
  updateCustomerEmail({ commit }, params) {
    connectManagerClient
      .updateCustomerEmail(params)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        console.error(error)
      })
  }
  */
}

export default {
  state,
  getters,
  mutations,
  actions,
}
